<template>
    <div class="nav-container">
        <div class="nav-left">
            <div class="nav-button nav-item-companies">
                <router-link to="/companies">Company Divisions</router-link>
            </div>
            <div class="spacer">|</div>
            <div class="nav-button">
                <router-link to="/groups">Parent Companies</router-link>
            </div>
        </div>
        <div class="nav-right">
            <div class="nav-button">
                <a @click="logout">Logout</a>
            </div>
            <div class="spacer">|</div>
            <div class="nav-button">
                <a class="about" @click="about()">About</a>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { inject } from 'vue';
    import { useRouter } from 'vue-router';
    import { openModal, promptModal } from "jenesius-vue-modal";
    import About from '../components/About.vue';
    import Error from '@/components/Error.vue';

    const api = inject('api');
    const router = useRouter();

    function about() {
        openModal(About);
    }

    async function logout() {
        try {
            await api.logout();
            router.replace('/login');
        }
        catch (err) {
            promptModal(Error, { message: 'Error logging out', details: err.stack });
        }
    }
</script>

<style scoped>
    .nav-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-color: #4b5259;
        padding: 20px;
    }

    .nav-left {
        display: flex;
        flex-direction: row;
        justify-content: left;
    }
    
    .nav-right {
        display: flex;
        flex-direction: row;
        justify-content: right;
    }
    
    .nav-button:not(:last-child) {
        /* margin-right: 20px; */
    }
    
    .nav-button > a {
        color: #ffffffcc;
        text-decoration: none;
        cursor: pointer;
    }

    .nav-button > a.router-link-active {
        font-weight: bold;
        color: white;
    }

    .nav-button > a:not(.router-link-active):hover {
        color: white;
    }

    .nav-item-companies {
        /* width: 135px; */
    }

    .spacer {
        color: #ffffffcc;
        margin-left: 10px;
        margin-right: 10px;
    }

    .about {
        color: #ffffffcc;
    }

    .about:hover {
        color: white;
    }
</style>
